import { ComponentProps } from 'react'

import { TribeRouterType } from '@tribeplatform/react-sdk'

export const ROUTE_MODE = {
  ADMIN: 'admin',
  DESIGN: 'design',
  MODERATION: 'moderation',
} as const

export type RouteMode = (typeof ROUTE_MODE)[keyof typeof ROUTE_MODE]

export type AnchorComponentProps = Omit<
  ComponentProps<TribeRouterType['Link']>,
  'href'
>

export type AnchorComponent = React.ForwardRefExoticComponent<
  AnchorComponentProps & React.RefAttributes<HTMLAnchorElement>
>

export type ModeAnchor = Partial<Record<RouteMode, AnchorComponent>>

export function createRouteModeAnchor(anchor: ModeAnchor) {
  return { mode: { anchor } }
}

export function createVisitSiteAnchor(anchor: AnchorComponent) {
  return { visitSite: { anchor } }
}
